"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Handles Measurement utilities.
 *
 * @param millimeter
 */
var MeasurementUtility = /** @class */ (function () {
    function MeasurementUtility() {
    }
    /**
     * Metric measurements to imperial measurements.
     *
     * @param millimeter Number to convert.
     * @param inFeet If it should contain feet.
     * @returns Numbers in imperial.
     */
    MeasurementUtility.metricToImperial = function (millimeter, inFeet) {
        var inInch = this.roundToEighths(this.millimeterToInch(millimeter));
        var feet = 0;
        var inches = '0';
        if (inFeet) {
            feet = (inInch / 12) << 0;
            inches = this.decimalsToFractions(inInch % 12);
        }
        else {
            inches = this.decimalsToFractions(inInch);
        }
        if (feet !== 0 && inches !== '0') {
            return feet + " ft " + inches + " in";
        }
        else if (feet !== 0) {
            return feet + " ft";
        }
        return inches + " in";
    };
    /**
     * Millimeter to inch.
     *
     * @param millimeter Number to convert.
     * @returns Number in Inches.
     */
    MeasurementUtility.millimeterToInch = function (millimeter) {
        return millimeter * 0.0393700787;
    };
    /**
     * Round a number to closest eighths.
     *
     * @param inch Number to convert.
     * @returns Number in Inches rounded to closest eights.
     */
    MeasurementUtility.roundToEighths = function (inch) {
        return parseFloat((Math.round(inch * 8) / 8).toFixed(3));
    };
    /**
     * Greatest common divisor.
     *
     * @param a Number.
     * @param b Number.
     * @returns Number the greatest common divisor.
     */
    MeasurementUtility.greatestCommonDivisor = function (a, b) {
        if (b === 0) {
            return a;
        }
        return this.greatestCommonDivisor(b, a % b);
    };
    /**
     * Decimals to fractions.
     *
     * @param decimals Number e.g 1.125.
     * @returns String the greatest common divisor.
     */
    MeasurementUtility.decimalsToFractions = function (decimals) {
        var decimalArray = decimals.toString().split('.');
        if (decimalArray.length === 1) {
            return decimalArray[0];
        }
        var leftDecimalPart = parseInt(decimalArray[0]);
        var rightDecimalPart = decimalArray[1];
        var numerator = parseInt(rightDecimalPart);
        var denominator = Math.pow(10, rightDecimalPart.length);
        var factor = this.greatestCommonDivisor(numerator, denominator);
        numerator /= factor;
        denominator /= factor;
        return leftDecimalPart !== 0
            ? leftDecimalPart + " " + numerator + "/" + denominator
            : numerator + "/" + denominator;
    };
    return MeasurementUtility;
}());
exports.default = MeasurementUtility;
//# sourceMappingURL=MeasurementUtility.js.map